import type { Invoice } from 'contracts/tracking-v2/invoices';

export const getInvoiceOrigin = (invoice: Invoice) => {
  const { supplier, originCity } = invoice;

  const supplierCity = supplier?.addressCity;
  const supplierUf = supplier?.addressUf;

  const invoiceCity = originCity?.name;
  const invoiceUf = originCity?.uf;

  const city = invoiceCity || supplierCity || '';
  const uf = invoiceUf || supplierUf || '';

  return {
    city,
    uf,
    asCityAndUfText: (separator = '/') => {
      return [city, uf].filter(Boolean).join(separator);
    }
  };
};

export const getInvoiceDestination = (invoice: Invoice) => {
  const { company, destinationCity } = invoice;

  const companyCity = company?.addressCity;
  const companyUf = company?.addressUf;

  const invoiceCity = destinationCity?.name;
  const invoiceUf = destinationCity?.uf;

  const city = invoiceCity || companyCity || '';
  const uf = invoiceUf || companyUf || '';

  return {
    city,
    uf,
    asCityAndUfText: (separator = '/') => {
      return [city, uf].filter(Boolean).join(separator);
    }
  }
}